import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { GridTypes } from '../../_components/GridDisplayView/GridTypes';
import { IBreakPoint } from '../../_interfaces/IBreakPoint';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import * as styles from '../../styles/styleObjects';
import { GridItems } from './GridItems';

import InfiniteScroll from 'react-infinite-scroller';

interface IGridState {
    breakpoints: Array<IBreakPoint>;
    currentBreakPoint: IBreakPoint;
    containerWidth: number;
}

interface IProps<T> extends RouteComponentProps<any> {
    store?: ApplicationStore;
    renderItem(item: T, index: number): JSX.Element;
    content: Array<T>;
    isSquareContent?: boolean;
    bottomPadding?: number;
    keyExtractor?(item: T): string | number;
    loadMore?: any;
    key?: any;
    infiniteScroll?: boolean;
    infiniteLoader?: any;
    infiniteloadMore?: any;
    infinitehasMore?: any;

}

@inject('store')
@observer
class CollectionGridClass<T> extends React.Component<IProps<T>, IGridState> {
    public divElement: HTMLElement | null = null;

    public constructor(props: IProps<T>) {
        super(props);
        const breakpoints: Array<IBreakPoint> = GridTypes.GetBreakPoint();

        console.assert(breakpoints !== undefined || null, 'No BreakPoints were found');
        console.assert(breakpoints.length > 0, 'No BreakPoints were found');

        const currentBreakPoint = breakpoints[0];

        this.state = {
            breakpoints,
            currentBreakPoint,
            containerWidth: 0
        };
    }

    private screenDidResize(item: HTMLElement | null): void {
        this.setBreakPoints(item);
    }

    private setBreakPoints(element: HTMLElement | null): void {
        if (element !== null) {
            const possibleBreakPoints = this.state.breakpoints.filter(bp => {
                return bp.containerIsWiderThan <= element.clientWidth;
            });

            console.assert(!(possibleBreakPoints.length === 0), 'Break Points are broken, you need a default "0" case');

            const currentBreakPoint: IBreakPoint = possibleBreakPoints[possibleBreakPoints.length - 1];
            this.setState({ currentBreakPoint, containerWidth: element.clientWidth });
        } else {
            console.assert(false, 'Grid Container is null');
        }
    }

    public componentDidMount(): void {
        if (this.divElement !== null) {
            const divElement = this.divElement;
            window.addEventListener('resize', () => this.screenDidResize(divElement));
            this.screenDidResize(divElement);
        } else {
            console.assert(false, 'GridDisplayView has a broken ref');
        }
    }

    public render() {
        return (
            <div style={{ ...styles.fullContainer, minWidth: 800 }} ref={divElement => (this.divElement = divElement)}>
                <div style={styles.fullContainer}>
                    {this.props.infiniteScroll ? (
                        <InfiniteScroll
                            initialLoad={false}
                            loader={this.props.infiniteLoader}
                            loadMore={this.props.infiniteloadMore}
                            hasMore={this.props.infinitehasMore}
                        >
                            <GridItems breakPoint={this.state.currentBreakPoint} containerWidth={this.state.containerWidth} {...this.props} />
                        </InfiniteScroll>
                    ) : (
                        <GridItems breakPoint={this.state.currentBreakPoint} containerWidth={this.state.containerWidth} {...this.props} />
                    )}

                </div>
            </div>

        );
    }
}

export const CollectionGrid = withRouter<IProps<any>>(CollectionGridClass);



// WEBPACK FOOTER //
// ./src/SharedComponents/GridDisplay/CollectionGrid.tsx